import {installConsoleApi} from "@cm/browser-log"

/**
 * Install the cmLog console API on the window object.
 * Call this once during application bootstrap.
 *
 * This provides runtime access to log configuration via browser console:
 *
 * @example
 * // In browser console:
 * cmLog.setLevel('debug')                    // Enable all logging
 * cmLog.setDomainLevel('api', 'debug')       // Debug only API calls
 * cmLog.setDomainLevel('routing', 'info')    // Info+ for routing
 * cmLog.getConfig()                          // View current config
 * cmLog.help()                               // Show help
 */
export function initializeConsoleApi(): void {
    installConsoleApi()
}
